import { ArcChart } from "./ArcCharts/ArcChart";

export class ArcChartComponent {
  constructor(container) {
    if (!container) {
      throw new Error('Container element is required');
    }

    this.container = container;
    this.elements = this.container.querySelectorAll('[data-chart-arcs]');
    this.components = [];

    if (this.elements.length > 0) {
      this.init();
    }
  }

  init() {
    this.elements.forEach(element => {
      const arcChart = new ArcChart(element);
      this.components.push(arcChart);
    })
  }

  dispose() {
    if(this.components.length) {
      this.components.forEach(component => {
        component.dispose();
      })
    }

    this.components = null;
    this.elements = null;
    this.container = null;
  }
}
